import { Typography } from '@mui/material';
import styled from 'styled-components';

export const Title = styled(Typography)`
  font-weight: 600;
  margin-bottom: 1em;
`;
